import { memo, useState } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

const CDN = 'https://wver.sprintstaticdata.com/v230/static/front/img/cards';
const CARD_FACES = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
const SUIT_IMGS = ['spade', 'heart', 'club', 'diamond'];

function findBySid(sub, sid) {
  return sub.find((s) => s.sid === sid || s.sid === String(sid));
}
function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}
function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}
function fmtAmt(n) {
  const v = Number(n) || 0;
  if (v >= 100000) return `${v / 100000}L`;
  if (v >= 1000) return `${v / 1000}K`;
  return String(v);
}
function bookOf(exposures, name) {
  return roundBook(exposures?.[name] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// book span + info-circle collapse range (Main / Under-Over boxes)
function RangeCollapse({ id, book, min, max }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="float-right">
      <span className={`mr-2 casino-book ${bookCls(book)}`}>{fmtBook(book)}</span>
      {' '}
      <i
        data-toggle="collapse"
        data-target={`#${id}`}
        aria-expanded={open ? 'true' : 'false'}
        className={`fas fa-info-circle${open ? '' : ' collapsed'}`}
        onClick={() => setOpen((v) => !v)}
      ></i>
      {' '}
      <div id={id} className={`icon-range collapse${open ? ' show' : ''}`}>
        {'\n                        R:'}
        <span>{fmtAmt(min)}</span>
        -
        <span>{fmtAmt(max)}</span>
      </div>
    </div>
  );
}

const BetTableTeen6 = memo(function BetTableTeen6({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const playerA = findBySid(sub, 1);
  const playerB = findBySid(sub, 2);
  const aUnder = findBySid(sub, 9);
  const aOver = findBySid(sub, 10);
  const bUnder = findBySid(sub, 11);
  const bOver = findBySid(sub, 12);

  const suitParent = sub.find((s) => s.subtype === 'suit' && s.odds?.length > 0) || sub.find((s) => s.subtype === 'suit');
  const suitOdds = suitParent?.odds || [];
  const suitsOpen = suitParent && !isSusp(suitParent);

  const oeParent = sub.find((s) => s.subtype === 'oddeven' && s.odds?.length > 0) || sub.find((s) => s.subtype === 'oddeven');
  const oeOdds = oeParent?.odds || [];
  const oddEntry = oeOdds.find((o) => o.nat === 'Odd') || oeOdds[0];
  const evenEntry = oeOdds.find((o) => o.nat === 'Even') || oeOdds[1];
  const oeOpen = oeParent && !isSusp(oeParent);

  const cardsParent = sub.find((s) => s.subtype === 'cards' && s.odds?.length > 0) || sub.find((s) => s.subtype === 'cards');
  const cardOddsArr = cardsParent?.odds || [];
  const cardsOpen = cardsParent && !isSusp(cardsParent);

  function PlayerBox({ label, item, className, side, rangeId, modalTitle }) {
    const book = bookOf(exposures, item?.nat);
    return (
      <div className={side}>
        <div className="casino-box-row d-none-small">
          <div className="casino-nation-name no-border casino-bl-box-title">
            <div className={className}>{label}</div>
          </div>
          {' '}
          <div className="casino-bl-box casino-bl-box-title">
            <div {...(modalTitle ? { 'data-toggle': 'modal' } : {})} className="casino-bl-box-item"><b>Back</b></div>
            {' '}
            <div className="casino-bl-box-item"><b>Lay</b></div>
          </div>
        </div>
        {' '}
        <div className="casino-box-row">
          <div className="casino-nation-name">
            <b className="d-none-small">Main</b>
            {' '}
            <b className="d-none-big">{label}</b>
            {' '}
            <RangeCollapse id={rangeId} book={book} min={item?.min ?? 50} max={item?.max ?? 200000} />
          </div>
          {' '}
          <div className="casino-bl-box">
            <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
              <span className="casino-box-odd">{item?.b ?? 0}</span>
            </div>
            {' '}
            <div className={`lay casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}>
              <span className="casino-box-odd">{item?.l ?? 0}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function UOBox({ label, underItem, overItem, className, side, underRange, overRange }) {
    const uBook = bookOf(exposures, underItem?.nat);
    const oBook = bookOf(exposures, overItem?.nat);
    return (
      <div className={side}>
        <div className="casino-box-row d-none-big">
          <div className="casino-nation-name no-border casino-bl-box-title">
            <div className={className}>{label}</div>
          </div>
          {' '}
          <div className="casino-bl-box casino-bl-box-title"></div>
        </div>
        {' '}
        <div className="casino-box-row">
          <div className="casino-nation-name">
            <b>Under 21</b>
            {' '}
            <RangeCollapse id={underRange} book={uBook} min={underItem?.min ?? 100} max={underItem?.max ?? 50000} />
          </div>
          {' '}
          <div className="casino-bl-box">
            <div className={`back casino-bl-box-item${suspCls(underItem)}`} onClick={isSusp(underItem) ? undefined : () => handleBet(underItem.sid, 'back', underItem.b, underItem)}>
              <span className="casino-box-odd">{underItem?.b ?? 0}</span>
            </div>
          </div>
          {' '}
          <div className="casino-nation-name">
            <b>Over 22</b>
            {' '}
            <RangeCollapse id={overRange} book={oBook} min={overItem?.min ?? 100} max={overItem?.max ?? 50000} />
          </div>
          {' '}
          <div className="casino-bl-box">
            <div className={`back casino-bl-box-item${suspCls(overItem)}`} onClick={isSusp(overItem) ? undefined : () => handleBet(overItem.sid, 'back', overItem.b, overItem)}>
              <span className="casino-box-odd">{overItem?.b ?? 0}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Main Player A vs B + Under/Over */}
      <div className="teen1daycasino-container">
        <PlayerBox label="Player A" item={playerA} className="playera" side="teen1dayleft" rangeId="range1" />
        {' '}
        <div className="teen1daycenter"></div>
        {' '}
        <PlayerBox label="Player B" item={playerB} className="playerb" side="teen1dayright" rangeId="range2" modalTitle />

        <div className="teen2uo">
          <UOBox label="Player A" underItem={aUnder} overItem={aOver} className="playera" side="teen1dayleft" underRange="range3" overRange="range4" />
          {' '}
          <div className="teen1daycenter"></div>
          {' '}
          <UOBox label="Player B" underItem={bUnder} overItem={bOver} className="playerb" side="teen1dayright" underRange="range5" overRange="range6" />
        </div>
      </div>
      {' '}
      {/* Suit */}
      <div className="tee2suit mt-1">
        <div className="casino-bl-box tee2suitheader">
          {SUIT_IMGS.map((suit) => {
            // odds array order API me fixed nahi ([Spade,Diamond,Club,Heart]) —
            // isliye nat se match karo, positional nahi (warna heart/diamond swap)
            const entry = suitOdds.find((o) => String(o.nat).toLowerCase() === suit);
            return (
              <div key={suit} className="casino-bl-box-item casino-card-img">
                <span className="casino-box-odd">{entry?.b ?? 0}</span>
              </div>
            );
          })}
        </div>
        {' '}
        <div className="casino-bl-box">
          {SUIT_IMGS.map((suit) => {
            const entry = suitOdds.find((o) => String(o.nat).toLowerCase() === suit);
            const odds = entry?.b ?? 0;
            // Bets are stored per card: "Card 1 Spade" (feed card nat + suit).
            const book = bookOf(exposures, `${suitParent?.nat} ${entry?.nat || ''}`);
            return (
              <div
                key={suit}
                className={`casino-bl-box-item back casino-card-img${book ? ' lock-top' : ''}${suitsOpen ? '' : ' suspended'}`}
                onClick={!suitsOpen ? undefined : () => handleBet(suitParent.sid, 'back', odds, { ...suitParent, nat: entry?.nat || suit, b: odds, selectedOddsSid: entry?.sid })}
              >
                <img src={`${CDN}/${suit}.png`} />
                {' '}
                <span className={`casino-book ${bookCls(book)}`}>{fmtBook(book)}</span>
              </div>
            );
          })}
        </div>
        {' '}
        <div className="casino-min-max text-right mt-4">
          {'\n                R:'}
          <span>{fmtAmt(suitParent?.min ?? 100)}</span>
          -
          <span>{fmtAmt(suitParent?.max ?? 5000)}</span>
        </div>
      </div>
      {' '}
      {/* Odd/Even + Cards */}
      <div className="row row5 mt-3">
        <div className="col-12 col-lg-4">
          <div className="teen2eo">
            <div className="casino-bl-box tee2eoheader">
              <div className="casino-bl-box-item casino-card-img"><span className="casino-box-odd">{oddEntry?.b ?? 0}</span></div>
              <div className="casino-bl-box-item casino-card-img"><span className="casino-box-odd">{evenEntry?.b ?? 0}</span></div>
            </div>
            {' '}
            <div className="casino-bl-box">
              {[['Odd', oddEntry], ['Even', evenEntry]].map(([lbl, entry]) => {
                // Stored per card: "Card 1 Odd".
                const book = bookOf(exposures, `${oeParent?.nat} ${lbl}`);
                return (
                  <div
                    key={lbl}
                    className={`casino-bl-box-item back${book ? ' lock-top' : ''}${oeOpen ? '' : ' suspended'}`}
                    onClick={!oeOpen ? undefined : () => handleBet(oeParent.sid, 'back', entry?.b ?? 0, { ...oeParent, nat: lbl, b: entry?.b ?? 0, selectedOddsSid: entry?.sid })}
                  >
                    <span className="casino-box-odd">{lbl}</span>
                    {' '}
                    <span className={`casino-book ${bookCls(book)}`}>{fmtBook(book)}</span>
                  </div>
                );
              })}
            </div>
          </div>
          {' '}
          <div className="casino-min-max text-right mt-3">
            {'\n                  R:'}
            <span>{fmtAmt(oeParent?.min ?? 100)}</span>
            -
            <span>{fmtAmt(oeParent?.max ?? 5000)}</span>
          </div>
        </div>
        {' '}
        <div className="col-12 col-lg-8">
          <div className="teen2cards">
            <div className="casino-cards text-center mt-1">
              {CARD_FACES.map((face) => {
                const entry = cardOddsArr.find((o) => o.nat === `Card ${face}`);
                const odds = entry?.b ?? 0;
                // Stored per card: "Card 1 A" (feed card nat + face).
                const book = bookOf(exposures, `${cardsParent?.nat} ${face}`);
                return (
                  <div key={face} className="casino-card-item">
                    <div className="casino-box-odd">{odds}</div>
                    {' '}
                    <div
                      className={`card-image${cardsOpen ? '' : ' suspended'}`}
                      onClick={!cardsOpen ? undefined : () => handleBet(cardsParent.sid, 'back', odds, { ...cardsParent, nat: `Card ${face}`, b: odds, selectedOddsSid: entry?.sid })}
                    >
                      <img src={`${CDN}/${face}.png`} />
                    </div>
                    {' '}
                    <div className={`casino-book ${bookCls(book)}`}>{fmtBook(book)}</div>
                  </div>
                );
              })}
            </div>
            {' '}
            <div className="casino-min-max text-right">
              {'\n                    R:'}
              <span>{fmtAmt(cardsParent?.min ?? 100)}</span>
              -
              <span>{fmtAmt(cardsParent?.max ?? 5000)}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default BetTableTeen6;
